import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 w-full" }

export function render(_ctx, _cache) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_Message = _resolveComponent("Message")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-[#d5be6e] text-base font-bold text-center" }, "กรอกชื่อ-นามสกุล (ภาษาอังกฤษ)", -1 /* HOISTED */)),
    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-[#d5be6e]/70 text-xs text-center mb-2" }, "จำเป็นสำหรับการทำรายการแบบ AutoPeer", -1 /* HOISTED */)),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createVNode(_component_IftaLabel, { class: "mt-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_InputText, {
            id: "first-name-en",
            class: "w-full bg-black/90! text-[#f5eded]! border-[#d5be6e]!",
            modelValue: _ctx.form.firstNameEn.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.firstNameEn.value) = $event)),
            invalid: _ctx.form.firstNameEn.invalid
          }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "first-name-en" }, "ชื่อจริง (อังกฤษ)", -1 /* HOISTED */))
        ]),
        _: 1 /* STABLE */,
        __: [3]
      }),
      (_ctx.form.firstNameEn.invalid)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            severity: "error",
            size: "small",
            variant: "simple",
            class: "mt-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.firstNameEn.errorMsg), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_IftaLabel, { class: "mt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_InputText, {
            id: "last-name-en",
            class: "w-full bg-black/90! text-[#f5eded]! border-[#d5be6e]!",
            modelValue: _ctx.form.lastNameEn.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.form.lastNameEn.value) = $event)),
            invalid: _ctx.form.lastNameEn.invalid
          }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "last-name-en" }, "นามสกุล (อังกฤษ)", -1 /* HOISTED */))
        ]),
        _: 1 /* STABLE */,
        __: [4]
      }),
      (_ctx.form.lastNameEn.invalid)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            severity: "error",
            size: "small",
            variant: "simple",
            class: "mt-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.lastNameEn.errorMsg), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_Button, {
        label: "บันทึก",
        type: "submit",
        class: "w-full bg-[#008f2c] mt-5",
        loading: _ctx.submitBtn.loading,
        disabled: _ctx.submitBtn.disabled
      }, null, 8 /* PROPS */, ["loading", "disabled"])
    ], 32 /* NEED_HYDRATION */)
  ]))
}